import { render, staticRenderFns } from "./registrationSurface.vue?vue&type=template&id=59410978&scoped=true"
import script from "./registrationSurface.vue?vue&type=script&lang=js"
export * from "./registrationSurface.vue?vue&type=script&lang=js"
import style0 from "./registrationSurface.vue?vue&type=style&index=0&id=59410978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59410978",
  null
  
)

export default component.exports